import { render } from "./SupplierForm.vue?vue&type=template&id=2fb33938"
import script from "./SupplierForm.vue?vue&type=script&lang=js"
export * from "./SupplierForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__